import { Badge, Button } from '@mantine/core'
import { get } from 'lodash'
import React, { ReactElement } from 'react'

import DeleteConfirmationDialog from '../../../../1stlog-ui/src/components/DeleteConfirmationDialog'
import useFieldValue from '../../../../1stlog-ui/src/components/Field/useFieldValue'
import Icon from '../../../../1stlog-ui/src/components/Icon'
import { TOrder } from '../../../../1stlog-ui/src/components/OrderDetails/helpers'
import ColiComponent from '../../../../shipmetrics-shared/containers/OrderEntry/Form/Colis/Coli'
import { Barcode } from '../../AuftragOrderList/Barcode'

type TColiProps = {
  index: number
  cancelColi: (id: string) => void
  order: TOrder
}

const Coli = (props: TColiProps): ReactElement => {
  const { index, cancelColi, order } = props

  const id = useFieldValue<string>('id')

  const isCancelled = useFieldValue<boolean>('isCancelled')
  const isCancellationAllowed = useFieldValue<boolean>('isCancellationAllowed')

  const coli = useFieldValue<any>(`colis.${index}`)

  const coliObject = order.colis.find((coli) => String(coli.id) === String(id))
  const coliState = coliObject
    ? get(order.coliStates, coliObject?.barcode1)
    : null

  return (
    <>
      <ColiComponent
        index={index}
        readonly
        showBarcode
        showColiCount
        barcodePrefixElement={
          <div
            className="ml-1"
            style={{
              display: 'inline-block',
              marginTop: '-4px',
            }}
          >
            <Barcode
              coli={{ ...coli, isCancelled }}
              coliState={coliState}
              isPickup={order.sla_object.isPickup}
            />
          </div>
        }
        headerElement={
          <div>
            {!isCancelled && isCancellationAllowed && (
              <DeleteConfirmationDialog
                title={i18n.t(
                  'confirm_coli_cancel',
                  'Coli wirklich stornieren?',
                )}
                confirmText={i18n.t(
                  'coli_storno_confirmation_btn',
                  'Ja, stornieren!',
                )}
                text="Möchten Sie dieses Coli wirklich stornieren?"
                onConfirm={() => {
                  cancelColi(id)
                }}
              >
                <Button size="xs" color="red" variant="subtle">
                  <Icon icon="far fa-ban" className="mr-2" />
                  {i18n.t('cancel_coli', 'Stornieren')}
                </Button>
              </DeleteConfirmationDialog>
            )}
            {isCancelled && (
              <div>
                <Badge color="red">
                  {i18n.t('coli_storniert', 'Storniert')}
                </Badge>
              </div>
            )}
            {!isCancelled && !isCancellationAllowed && (
              <div>
                <Button size="xs" color="red" variant="subtle" disabled>
                  <Icon icon="far fa-ban" className="mr-2" />
                  {i18n.t(
                    'cancel_coli_not_allowed',
                    'Stornieren nicht möglich',
                  )}
                </Button>
              </div>
            )}
          </div>
        }
      />
    </>
  )
}

export default Coli
